<template>
  <c-row>
    <c-col col="12" lg="6">
      <c-card>
        <c-card-header>User id: {{ $route.params.id }}</c-card-header>
        <c-card-body>
          <c-data-table striped small fixed :items="visibleData" :fields="fields" />
        </c-card-body>
        <c-card-footer>
          <c-button color="primary" @click="goBack">Back</c-button>
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>

<script>
import usersData from './UsersData';

export default {
  name: 'User',
  computed: {
    fields() {
      return [
        { key: 'key', label: this.username, _style: 'width:150px' },
        { key: 'value', label: '', _style: 'width:150px;' },
      ];
    },
    userData() {
      const { id } = this.$route.params;
      const user = usersData.find((user, index) => index + 1 == id);
      const userDetails = user ? Object.entries(user) : [['id', 'Not found']];
      return userDetails.map(([key, value]) => ({ key, value }));
    },
    visibleData() {
      return this.userData.filter((param) => param.key !== 'username');
    },
    username() {
      return this.userData.filter((param) => param.key === 'username')[0].value;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
